// /* eslint-disable no-unused-vars */
// import React, { useState, useMemo, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   createLoanScheme,
//   fetchLoanSchemes,
//   updateLoanScheme,
//   deleteLoanScheme,
//   resetLoanState,
//   createServiceType,
//   createService,
//   updateService,
// } from "../../redux/slices/loanSchemeSlice";
// import { fetchAllServiceTypes } from "../../redux/slices/service_type";
// import { toast } from "react-toastify";
// import { FaEdit, FaTrash } from "react-icons/fa";
// import "./GroupLoanScheme.css"

// const roiFrequencies = [
//   "Monthly",
//   // "Quarterly",
//   // "Half-Yearly",
//   "Yearly",
//   // "Weekly",
// ];
// const tenureTypes = [
//   "Monthly",
//   "Quarterly",
//   "Half-Yearly",
//   "Yearly",
//   "Weekly",
//   "bi-weekly",
//   "Days",
// ];
// const recoveryFrequencys = [
//   "Monthly",
//   "Quarterly",
//   "Half-Yearly",
//   "Yearly",
//   "Weekly",
//   "bi-weekly",
//   "Daily",
// ];

// const GroupLoanScheme = () => {
//   const dispatch = useDispatch();
//   const { loading, success, error, list } = useSelector(
//     (state) => state.loanScheme
//   );
//   const { allServiceTypes } = useSelector((state) => state.serviceType);

//   const [formData, setFormData] = useState({
//     serviceType: "",
//     serviceTypeId: "",
//     serviceName: "",
//     minAmount: "",
//     maxAmount: "",
//     prefix: "",
//     maxTenure: "",
//     roi: "",
//     roiType: "",
//     roiFrequency: "",
//     minMember: "",
//     maxMember: "",
//     fixedEmiAmount: "",
//     fixedLoanAmount: "",
//     fixedLoanTenure: "",
//     fixedLoanFrequency: "",
//     tenureType: "Months",
//     recoveryFrequency: "Monthly",
//     active: false,
//   });

//   const [editId, setEditId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [serviceId, setServiceId] = useState(null);

//   useEffect(() => {
//     dispatch(fetchAllServiceTypes());
//     dispatch(fetchLoanSchemes());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) toast.success("Loan scheme submitted successfully.");
//     if (error) toast.error("Error: " + error);
//     dispatch(resetLoanState());
//   }, [success, error, dispatch]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name === "serviceType") {
//       const selected = allServiceTypes.find((stype) => stype.name === value);
//       setFormData((prev) => ({
//         ...prev,
//         serviceType: value,
//         serviceTypeId: selected?.id || null,
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//       }));
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const payload = {
//       serviceName: formData.serviceName,
//       serviceType: formData.serviceType,
//       serviceTypeId: formData.serviceTypeId,
//       minAmount: formData.minAmount || null,
//       maxAmount: formData.maxAmount || null,
//       maxTenure: formData.maxTenure || null,
//       schemeStatus: formData.active ? "Active" : "Inactive",
//       isFixedTenure: ["Fixed Loan"].includes(formData.serviceType),
//       roi: formData.roi || null,
//       roiFrequency: formData.roiFrequency,
//       roiType: formData.roiType,
//       prefix: formData.prefix,
//       fixedEmiAmount: formData.fixedEmiAmount || null,
//       fixedLoanAmount: formData.fixedLoanAmount || null,
//       fixedLoanTenure: formData.fixedLoanTenure || null,
//       fixedLoanFrequency: formData.fixedLoanFrequency || formData.roiFrequency,
//       minMember: formData.minMember || null,
//       maxMember: formData.maxMember || null,
//       tenureType: formData.tenureType || null,
//       recoveryFrequency: formData.recoveryFrequency || null,
//       superAdminId: localStorage.getItem("adminuserId"),
//     };

//     if (editId) {
//       dispatch(updateLoanScheme({ id: editId, data: payload }))
//         .unwrap()
//         .then(() => {
//           toast.success("Loan scheme updated ✅");
//           dispatch(fetchLoanSchemes());

//           if (serviceId) {
//             dispatch(
//               updateService({
//                 id: serviceId,
//                 data: {
//                   name: formData.serviceName,
//                   description: `Service for scheme ${formData.serviceName}`,
//                   superadminId: localStorage.getItem("adminuserId"),
//                   branchId: localStorage.getItem("adminuserId"),
//                   serviceTypeId: formData.serviceTypeId,
//                 },
//               })
//             )
//               .unwrap()
//               .then(() => toast.success("Service updated ✅"))
//               .catch((err) => toast.error("Service update failed: " + err));
//           }
//         });
//     } else {
//       dispatch(createLoanScheme(payload))
//         .unwrap()
//         .then(() => {
//           toast.success("Loan scheme created ✅");
//           dispatch(fetchLoanSchemes());

//           dispatch(
//             createService({
//               name: formData.serviceName,
//               description: `Service for scheme ${formData.serviceName}`,
//               superadminId: localStorage.getItem("adminuserId"),
//               branchId: localStorage.getItem("adminuserId"),
//               serviceTypeId: formData.serviceTypeId,
//             })
//           )
//             .unwrap()
//             .then((serviceRes) => {
//               toast.success("Service created ✅");

//               // Save created service ID
//               setServiceId(serviceRes.data.id || serviceRes.id || null);
//             })
//             .catch((err) => toast.error("Service creation failed: " + err));
//         })
//         .catch((err) => toast.error("Failed to create loan scheme: " + err));
//     }

//     // Reset form and IDs
//     setFormData({
//       serviceType: "",
//       serviceName: "",
//       serviceTypeId: null,
//       minAmount: "",
//       maxAmount: "",
//       prefix: "",
//       maxTenure: "",
//       roi: "",
//       roiType: "",
//       roiFrequency: "",
//       minMember: "",
//       maxMember: "",
//       fixedEmiAmount: "",
//       fixedLoanAmount: "",
//       fixedLoanTenure: "",
//       fixedLoanFrequency: "",
//       tenureType: "Months",
//       recoveryFrequency: "Monthly",
//       active: false,
//     });

//     setEditId(null);
//     setServiceId(null);
//   };

//   const handleEdit = (loan) => {
//     setFormData({
//       ...loan,
//       active: loan.schemeStatus === "Active",
//       serviceType: loan.serviceType || "",
//       tenureType: loan.tenureType || "Months",
//       recoveryFrequency: loan.recoveryFrequency || "Monthly",
//     });

//     setServiceId(loan.serviceId || null);

//     setEditId(loan.id);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this loan scheme?")) {
//       dispatch(deleteLoanScheme(id)).then(() => dispatch(fetchLoanSchemes()));
//     }
//   };

//   const filteredLoans = useMemo(() => {
//     return list.filter(
//       (loan) =>
//         loan.serviceType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         loan.serviceName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         loan.prefix?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [list, searchTerm]);

//   const totalPages = Math.ceil(filteredLoans.length / entriesPerPage);
//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const displayedLoans = filteredLoans.slice(
//     startIndex,
//     startIndex + entriesPerPage
//   );

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) setCurrentPage(page);
//   };

//   return (
//     <>
//       <div className="group-loan-scheme-container">
//         <section className="group-loan-scheme-section">
//           <h2>Group Loan Scheme Creation</h2>
//           <form onSubmit={handleSubmit}>
//             <div className="group-loan-scheme-grid-container">
//               {/* Service Type */}
//               <div>
//                 <label>Service Type</label>
//                 <select
//                   name="serviceType"
//                   value={formData.serviceType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">-- Select Service Type --</option>
//                   {allServiceTypes.map((stype) => (
//                     <option key={stype.id} value={stype.name}>
//                       {stype.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Service Name */}
//               <div>
//                 <label>Service Name</label>
//                 <input
//                   type="text"
//                   name="serviceName"
//                   className="group-loan-scheme-admin-serviceName-input"
//                   value={formData.serviceName}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* Conditional Fields */}
//               {[
//                 "Personal Loan",
//                 "Mortgage Loan",
//                 "CC Loan",
//                 "Group Loan",
//               ].includes(formData.serviceType) && (
//                 <>
//                   <div>
//                     <label>Min Amount</label>
//                     <input
//                       type="number"
//                       name="minAmount"
//                       value={formData.minAmount}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>Max Amount</label>
//                     <input
//                       type="number"
//                       name="maxAmount"
//                       value={formData.maxAmount}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>Max Tenure</label>
//                     <input
//                       type="number"
//                       name="maxTenure"
//                       value={formData.maxTenure}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>ROI</label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       name="roi"
//                       value={formData.roi}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>ROI Type</label>
//                     <select
//                       name="roiType"
//                       value={formData.roiType}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select ROI Type</option>
//                       {/* <option value="Fixed">Fixed</option> */}
//                       {/* <option value="Floating">Floating</option> */}
//                       <option value="Flat">Flat</option>
//                       <option value="Reducing">Reducing</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label>ROI Frequency</label>
//                     <select
//                       name="roiFrequency"
//                       value={formData.roiFrequency}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Frequency</option>
//                       {roiFrequencies.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label>Tenure Type</label>
//                     <select
//                       name="tenureType"
//                       value={formData.tenureType}
//                       onChange={handleChange}
//                     >
//                       {tenureTypes.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label>Recovery Frequency</label>
//                     <select
//                       name="recoveryFrequency"
//                       value={formData.recoveryFrequency}
//                       onChange={handleChange}
//                     >
//                       {recoveryFrequencys.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label>Prefix</label>
//                     <input
//                       type="text"
//                       className="group-loan-scheme-admin-serviceName-input"
//                       name="prefix"
//                       value={formData.prefix}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                 </>
//               )}

//               {/* Fixed Loan Fields */}
//               {formData.serviceType === "Fixed Loan" && (
//                 <>
//                   <div>
//                     <label>Fixed Loan Amount</label>
//                     <input
//                       type="number"
//                       name="fixedLoanAmount"
//                       value={formData.fixedLoanAmount}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>Fixed EMI Amount</label>
//                     <input
//                       type="number"
//                       name="fixedEmiAmount"
//                       value={formData.fixedEmiAmount}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>Fixed Loan Tenure</label>
//                     <input
//                       type="number"
//                       name="fixedLoanTenure"
//                       value={formData.fixedLoanTenure}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>Fixed Loan Frequency</label>
//                     <select
//                       name="fixedLoanFrequency"
//                       value={formData.fixedLoanFrequency}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Frequency</option>
//                       {roiFrequencies.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label>ROI</label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       name="roi"
//                       value={formData.roi}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div>
//                     <label>ROI Type</label>
//                     <select
//                       name="roiType"
//                       value={formData.roiType}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select ROI Type</option>
//                       {/* <option value="Fixed">Fixed</option> */}
//                       {/* <option value="Floating">Floating</option> */}
//                       <option value="Flat">Flat</option>
//                       <option value="Reducing">Reducing</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label>ROI Frequency</label>
//                     <select
//                       name="roiFrequency"
//                       value={formData.roiFrequency}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Frequency</option>
//                       {roiFrequencies.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label>Tenure Type</label>
//                     <select
//                       name="tenureType"
//                       value={formData.tenureType}
//                       onChange={handleChange}
//                     >
//                       {tenureTypes.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div>
//                     <label>Recovery Frequency</label>
//                     <select
//                       name="recoveryFrequency"
//                       value={formData.recoveryFrequency}
//                       onChange={handleChange}
//                     >
//                       {roiFrequencies.map((freq) => (
//                         <option key={freq} value={freq}>
//                           {freq}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div></div>
//                   <div>
//                     <label>Prefix</label>
//                     <input
//                       type="text"
//                       className="group-loan-scheme-admin-serviceName-input"
//                       name="prefix"
//                       value={formData.prefix}
//                       onChange={handleChange}
//                       required
//                     />
//                   </div>
//                 </>
//               )}
//             </div>

//             <div className="group-loan-scheme-checkbox-container">
//               <input
//                 type="checkbox"
//                 name="active"
//                 checked={formData.active}
//                 onChange={handleChange}
//               />
//               <label>Active</label>
//             </div>

//             <button type="submit" disabled={loading}>
//               {loading
//                 ? "Submitting..."
//                 : editId
//                 ? "Update Loan Scheme"
//                 : "Add Loan Scheme"}
//             </button>
//           </form>
//         </section>

//         {/* Table */}
//         <section className="group-loan-scheme-report-section">
//           <h2 className="group-loan-scheme-report-table-header">Group Loan Scheme Report</h2>
//           <div className="group-loan-scheme-table-wrapper">
//             <table className="group-loan-scheme-table">
//               <thead>
//                 <tr>
//                   <th>S.No.</th>
//                   <th>Service Type</th>
//                   <th>Service Name</th>
//                   <th>Min Amount</th>
//                   <th>Max Amount</th>
//                   <th>Max Tenure</th>
//                   <th>Tenure Type</th>
//                   <th>Recovery Frequency</th>
//                   <th>Scheme Status</th>
//                   <th>Is Fixed Tenure</th>
//                   <th>ROI</th>
//                   <th>ROI Frequency</th>
//                   <th>ROI Type</th>
//                   <th>Prefix</th>
//                   <th>Fixed EMI Amount</th>
//                   <th>Fixed Loan Amount</th>
//                   <th>Fixed Loan Tenure</th>
//                   <th>Fixed Loan Frequency</th>
//                   {/* <th>Roi</th> */}
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayedLoans.length === 0 ? (
//                   <tr>
//                     <td colSpan="19" style={{ textAlign: "center" }}>
//                       No data found
//                     </td>
//                   </tr>
//                 ) : (
//                   displayedLoans.map((loan, index) => (
//                     <tr key={loan.id}>
//                       <td>{startIndex + index + 1}</td>
//                       <td>{loan.serviceType}</td>
//                       <td>{loan.serviceName}</td>
//                       <td>{loan.minAmount}</td>
//                       <td>{loan.maxAmount}</td>
//                       <td>{loan.maxTenure}</td>
//                       <td>{loan.tenureType}</td>
//                       <td>{loan.recoveryFrequency}</td>
//                       <td>{loan.schemeStatus}</td>
//                       <td>{loan.isFixedTenure ? "Yes" : "No"}</td>
//                       <td>{loan.roi}</td>
//                       <td>{loan.roiFrequency}</td>
//                       <td>{loan.roiType}</td>
//                       <td>{loan.prefix}</td>
//                       <td>{loan.fixedEmiAmount}</td>
//                       <td>{loan.fixedLoanAmount}</td>
//                       <td>{loan.fixedLoanTenure}</td>
//                       <td>{loan.fixedLoanFrequency}</td>
//                       <td>
//                         <button
//                           className="group-loan-scheme-report-edit-btn"
//                           onClick={() => handleEdit(loan)}
//                         >
//                           <FaEdit />
//                         </button>
//                         <button
//                           className="group-loan-scheme-report-delete-btn"
//                           onClick={() => handleDelete(loan.id)}
//                         >
//                           <FaTrash />
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="group-loan-scheme-pagination">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default GroupLoanScheme;



// ----------------------------------------------
/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import "./GroupLoanScheme.css";
import { toast } from "react-toastify";

const roiFrequencies = ["Monthly", "Yearly"];
// const tenureTypes = [
//   "Monthly",
//   "Quarterly",
//   "Half-Yearly",
//   "Yearly",
//   "Weekly",
//   "bi-weekly",
//   "Days",
// ];
const recoveryFrequencies = [
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
  "Weekly",
  "bi-weekly",
  "Daily",
];

const GroupLoanScheme = () => {
  const initialForm = {
    serviceType: "",
    serviceName: "",
    serviceTypeId: "",
    minAmount: "",
    maxAmount: "",
    prefix: "",
    maxTenure: "",
    roi: "",
    roiType: "",
    roiFrequency: "",
    tenureType: "Months",
    recoveryFrequency: "Monthly",
    active: false,
  };

  const [formData, setFormData] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Fetch all loan schemes
  const fetchLoans = async () => {
    const superAdminId=localStorage.getItem("adminuserId")
    setLoading(true);
    try {
      const res = await axios.get(
        `https://payyug.in/api/premium-scheme/get-all?superAdminId=${superAdminId}`
      );
      console.log(res.data.data)
      setLoanData(res.data.data || []);
    } catch (error) {
      alert("Failed to fetch Loan Data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  // Submit form (Create + Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.serviceType || !formData.serviceName) {
      alert("Please fill all required fields");
      return;
    }

    const payload = {
      serviceName: formData.serviceName,
      serviceType: formData.serviceType,
      rateOfInterest: Number(formData.roi),
      recoveryType: formData.recoveryFrequency,
      minAmount: formData.minAmount,
      maxAmount: formData.maxAmount,
      nDays: 7,
      noOfPayments: 25,
      amount: 20000,
      noOfAdvanceInstallment: 1,
      processingFee: 2,
      processingFeeIncludeAmt: true,
      fileCharge: 100,
      fileChargeIncludeAmt: false,
      insuranceFee: 50,
      insuranceFeeType: "percent",
      insuranceFeeIncludeAmt: true,
      includeGst: true,
      holidayInclude: false,
      totalAmtToPay: 24000,
      emi: 960,
      roiType: formData.roiType,
      prefix: formData.prefix,
      roiFrequency: formData.roiFrequency,
      maxTenure: formData.maxTenure,
      superAdminId: Number(localStorage.getItem("adminuserId")||47),
      status: formData.active ? "Active" : "Inactive",
    };

    try {
      if (editId === null) {
        // CREATE
        const res = await axios.post(
          "https://payyug.in/api/premium-scheme/create",
          payload
        );
        console.log(res.data.data)
        // alert(res.data?.message || "Loan Scheme Added");
        toast.success(res.data?.message || "Loan Scheme Added");
      } else {
        // UPDATE
        const res = await axios.put(
          `https://payyug.in/api/premium-scheme/update/${editId}`,
          payload
        );
        // alert(res.data?.message || "Loan Scheme Updated");
        toast.success(res.data?.message || "Loan Scheme Updated");
      }

      // Reset
      setFormData(initialForm);
      setEditId(null);
      fetchLoans();
    } catch (err) {
      // alert(err.response?.data?.message || "Failed to Create/Update Scheme");
      toast.error(err.response?.data?.message || "Failed to Create/Update Scheme");
    }
  };

  // Delete Function
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this scheme?")) return;

    try {
      const res = await axios.delete(
        `https://payyug.in/api/premium-scheme/delete/${id}`
      );
      // alert(res.data?.message || "Deleted successfully");
      toast.success(res.data?.message || "Deleted successfully");

      fetchLoans();
    } catch (err) {
      // alert("Failed to delete loan data");
      toast.error("Failed to delete loan data");
    }
  };

  // Edit Function (Load Data to Form)
  const handleEdit = (loan) => {
    setEditId(loan.id);

    setFormData({
      serviceType: loan.serviceType,
      serviceName: loan.serviceName,
      minAmount: loan.minAmount,
      maxAmount: loan.maxAmount,
      prefix: loan.prefix,
      maxTenure: loan.maxTenure,
      roi: loan.rateOfInterest,
      roiType: loan.roiType,
      roiFrequency: loan.roiFrequency,
      tenureType: loan.tenureType,
      recoveryFrequency: loan.recoveryType,
      active: loan.status === "Active",
    });
  };

  // Filter and Pagination
  const filteredLoans = useMemo(() => {
    return loanData.filter(
      (loan) =>
        loan.serviceType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        loan.serviceName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        loan.prefix?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [loanData, searchTerm]);

  const totalPages = Math.ceil(filteredLoans.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;

  const displayedLoans = filteredLoans.slice(
    startIndex,
    startIndex + entriesPerPage
  );

  return (
    <div className="group-loan-scheme-container">
      {/* ---------------- FORM ---------------- */}
      <section className="group-loan-scheme-section">
        <h2>{editId ? "Update Loan Scheme" : "Create Group Loan Scheme"}</h2>

        <form onSubmit={handleSubmit}>
          <div className="group-loan-scheme-grid-container">
            <div>
              <label>Service Type</label>
              <select
                name="serviceType"
                value={formData.serviceType}
                onChange={handleChange}
                required
              >
                <option value="">-- Select --</option>
                <option value="JLG Group">JLG Group</option>
                <option value="JLG Individual">JLG Individual</option>
                <option value="Individual">Individual</option>
                <option value="SHG Group">SHG Group</option>
              </select>
            </div>

            <div>
              <label>Service Name</label>
              <input
                type="text"
                name="serviceName"
                value={formData.serviceName}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>Min Amount</label>
              <input
                type="number"
                name="minAmount"
                value={formData.minAmount}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>Max Amount</label>
              <input
                type="number"
                name="maxAmount"
                value={formData.maxAmount}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>Max Tenure</label>
              <input
                type="number"
                name="maxTenure"
                value={formData.maxTenure}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>ROI</label>
              <input
                type="number"
                name="roi"
                value={formData.roi}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>ROI Type</label>
              <select
                name="roiType"
                value={formData.roiType}
                onChange={handleChange}
              >
                <option value="">Select ROI Type</option>
                <option value="Flat">Flat</option>
                <option value="Reducing">Reducing</option>
              </select>
            </div>

            <div>
              <label>ROI Frequency</label>
              <select
                name="roiFrequency"
                value={formData.roiFrequency}
                onChange={handleChange}
              >
                <option value="">Select</option>
                {roiFrequencies.map((f) => (
                  <option key={f} value={f}>
                    {f}
                  </option>
                ))}
              </select>
            </div>

            {/* <div>
              <label>Tenure Type</label>
              <select
                name="tenureType"
                value={formData.tenureType}
                onChange={handleChange}
              >
                {tenureTypes.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </div> */}

            <div>
              <label>Recovery Frequency</label>
              <select
                name="recoveryFrequency"
                value={formData.recoveryFrequency}
                onChange={handleChange}
              >
                {recoveryFrequencies.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label>Prefix</label>
              <input
                type="text"
                name="prefix"
                value={formData.prefix}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="group-loan-scheme-checkbox-container">
            <input
              type="checkbox"
              name="active"
              checked={formData.active}
              onChange={handleChange}
            />
            <label>Active</label>
          </div>

          <button type="submit">
            {editId ? "Update Group Loan Scheme" : "Add Group Loan Scheme"}
          </button>
        </form>
      </section>

      {/* ---------------- TABLE ---------------- */}
      <div className="group-loan-scheme-report-section">
        <h2>Group Loan Scheme Report</h2>

        <div className="group-loan-scheme-table-wrapper">
          <table className="group-loan-scheme-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Service Type</th>
                <th>Service Name</th>
                <th>Min</th>
                <th>Max</th>
                <th>Tenure</th>
                {/* <th>Tenure Type</th> */}
                <th>Recovery</th>
                <th>ROI</th>
                <th>ROI Freq</th>
                <th>ROI Type</th>
                <th>Prefix</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : displayedLoans.length === 0 ? (
                <tr>
                  <td colSpan="15" style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              ) : (
                displayedLoans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td>{startIndex + index + 1}</td>
                    <td>{loan.serviceType||"N/A"}</td>
                    <td>{loan.serviceName||"N/A"}</td>
                    <td>{loan.minAmount||"N/A"}</td>
                    <td>{loan.maxAmount||"N/A"}</td>
                    <td>{loan.maxTenure||"N/A"}</td>
                    {/* <td>{loan.tenureType}</td> */}
                    <td>{loan.recoveryType||"N/A"}</td>
                    <td>{loan.rateOfInterest||"N/A"}</td>
                    <td>{loan.roiFrequency||"N/A"}</td>
                    <td>{loan.roiType||"N/A"}</td>
                    <td>{loan.prefix||"N/A"}</td>
                    <td>{loan.status||"N/A"}</td>

                    <td>
                      <button
                        className="group-loan-scheme-report-edit-btn"
                        onClick={() => handleEdit(loan)}
                      >
                        <FaEdit />
                      </button>

                      <button
                        className="group-loan-scheme-report-delete-btn"
                        onClick={() => handleDelete(loan.id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

        </div>
      </div>

      {/* Pagination */}
          <div className="group-loan-scheme-pagination">
            <button
              onClick={() => setCurrentPage((p) => p - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={() => setCurrentPage((p) => p + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
    </div>
  );
};

export default GroupLoanScheme;
